import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-63e5e4f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "p_personal_data",
  class: "p_personal_data"
}
const _hoisted_2 = { class: "form_box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_box__title" }, "Personal information", -1))
const _hoisted_4 = {
  class: "main_form",
  "data-toggle": "validator"
}
const _hoisted_5 = { class: "field_wrapper" }
const _hoisted_6 = { class: "field_box" }
const _hoisted_7 = { class: "field form-group" }
const _hoisted_8 = { class: "field form-group" }
const _hoisted_9 = { class: "field form-group" }
const _hoisted_10 = { class: "field form-group" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.Name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Name) = $event)),
                readOnly: !_ctx.IsEdit,
                headerText: _ctx.$localization.getTranslate('Name')
              }, null, 8, ["modelValue", "readOnly", "headerText"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.Person.LastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Person.LastName) = $event)),
                readOnly: !_ctx.IsEdit,
                headerText: _ctx.$localization.getTranslate('LastName')
              }, null, 8, ["modelValue", "readOnly", "headerText"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.Phone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Phone) = $event)),
                readOnly: !_ctx.IsEdit,
                headerText: _ctx.$localization.getTranslate('Phone')
              }, null, 8, ["modelValue", "readOnly", "headerText"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.Email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Email) = $event)),
                readOnly: !_ctx.IsEdit,
                headerText: "Email"
              }, null, 8, ["modelValue", "readOnly"])
            ])
          ])
        ]),
        (_ctx.IsEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.ErrorMessage), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}